import { FC } from "react";

export const HelperText: FC<{ text: string }> = (props: { text: string }) => {
    return <div className="text-muted"><small>{props.text}</small></div>;
};
